import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/user/Layout";
import OrderListPartner from "../../components/user/order/OrderListPartner";
const Order = () => {
  const siteName = useSelector(
    (state) => state.globalState?.siteSetting?.site_settings?.site_name
  );

  return (
    <Layout>
      <Helmet>
        <title>Orders - {siteName}</title>
      </Helmet>
      <OrderListPartner />
    </Layout>
  );
};

export default Order;
